import script from "./ReviewForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewForm.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewForm.vue?vue&type=style&index=0&id=568b90f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568b90f0"]])

export default __exports__